module.exports = __webpack_public_path__ + "images/emoji/sheep.dcd5a9fdeaa6a4d679f9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sheep.png
// module id = 2v/j
// module chunks = 24